import { emptySplitApi as api } from "./emptyApi"
import {
  PipelineEventControllerGetPipelineProgressApiResponse,
  PipelineEventControllerGetPipelineProgressApiArg,
} from "./types/pipeline-event.types"

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    pipelineEventControllerGetPipelineProgress: build.query<
      PipelineEventControllerGetPipelineProgressApiResponse,
      PipelineEventControllerGetPipelineProgressApiArg
    >({
      // companyId separates caches when switching companies; it is not sent to the API.
      query: () => ({ url: `/pipeline-event/progress` }),
      providesTags: ["PipelineProgress"],
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as generatedApi }

// Export hooks
export const { usePipelineEventControllerGetPipelineProgressQuery } =
  injectedRtkApi

// Re-export types that are needed by components
export type {
  PipelineProgressResponseDto,
  CompanyPipelineProgressDto,
  PipelinePhaseDto,
  PipelineEventStatusDto,
  PipelineEventDto,
} from "./types/pipeline-event.types"
